import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteGrids,
	deleteGrid,
	deleteGridFail,
	deleteGridSuccess,
	fetchGridListFail,
	fetchGridListSuccess,
	initGridList,
	refreshGridList,
	updateIncludePublic,
} from './grid.actions';
import { GridOriginalSliceState } from './grid.state';

export const gridOriginalReducer = createReducer<GridOriginalSliceState>(
	new GridOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initGridList, refreshGridList, (state) => state.setLoading(true)),
	on(fetchGridListSuccess, (state, action) =>
		state.setLoading(false).setGridList(action.gridList)
	),
	on(fetchGridListFail, (state) => state.setLoading(false)),
	on(deleteGrid, bulkDeleteGrids, (state) => state.setLoading(true)),
	on(deleteGridSuccess, (state) => state.setDeleteSuccess(true)),
	on(deleteGridFail, (state) =>
		state.setDeleteSuccess(false).setLoading(false)
	),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	)
);
